import { useEffect, useState } from 'react';

export default function useIsMobileDevice() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobileDevice = () => {
      // Check user agent for mobile devices
      const isPhoneUA = /Mobi|Android|iPhone/i.test(navigator.userAgent);
      
      // Check if device has touch capability
      const isTouch = window.matchMedia('(pointer: coarse)').matches;
      
      // Check screen width
      const isSmallScreen = window.innerWidth <= 768;
      
      // Determine if it's a mobile device
      const mobileDevice = (isPhoneUA && isTouch) || isSmallScreen;
      
      setIsMobile(mobileDevice);
      
      // Add/remove CSS class for styling purposes
      if (mobileDevice) {
        document.body.classList.add('mobile-device');
      } else {
        document.body.classList.remove('mobile-device');
      }
    };

    // Check initially
    checkMobileDevice();

    // Add resize listener to handle orientation changes and window resizing
    const handleResize = () => {
      checkMobileDevice();
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
} 